"use client";

import { useTranslations } from "next-intl";
import { cn, Text, VStack } from "@/ui";

interface NotFoundProps {
  title?: string;
  description?: string;
  className?: string;
}

export const NotFound = (props: NotFoundProps) => {
  const { title, description, className } = props;
  const notFoundT = useTranslations("not_found");

  return (
    <VStack className={cn("my-auto items-center px-4 py-4 sm:px-6 sm:py-8", className)}>
      <Text className="text-sm font-semibold uppercase tracking-wide text-foreground/75">
        {title ? title : notFoundT("title")}
      </Text>
      <Text className="mt-2 text-center text-3xl font-extrabold tracking-tight sm:text-4xl">
        {description ? description : notFoundT("subtitle")}
      </Text>
    </VStack>
  );
};
